var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9442 9.64948C11.8701 9.51192 11.7387 9.44329 11.6085 9.47512L7.54565 10.4515L8.3706 0.522103C8.38635 0.333351 8.29694 0.156776 8.15338 0.0931201C8.0096 0.0297413 7.85118 0.0961645 7.76776 0.255027L0.0541147 14.9445C-0.0186617 15.0829 -0.0179962 15.2611 0.0558896 15.3981C0.12911 15.5346 0.260463 15.6035 0.391593 15.573L4.45465 14.5963L3.6297 24.5255C3.61395 24.7148 3.70337 24.8914 3.84692 24.9548C3.8822 24.9703 3.91926 24.9783 3.95698 24.9783C4.06836 24.9783 4.17109 24.9088 4.23233 24.7929L11.946 10.1034C12.0187 9.96499 12.0179 9.78675 11.9442 9.64948Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.fdaa4e5bad5d86c0d9fbd03e344e8df2.svg";
export { ForwardRef as ReactComponent };